<div if.bind="account.signupNudgeOpen" class="modal-overlay" click.trigger="account.dismissSignupNudge()">
  <div class="login-modal signup-nudge" click.trigger="$event.stopPropagation()">
    <h3 class="signup-nudge__title">Create a free account</h3>
    <p class="signup-nudge__message">${account.signupNudgeMessage}</p>
    <div class="login-actions signup-nudge__actions">
      <button type="button" class="login-btn login-btn--primary signup-nudge__cta" click.trigger="account.signUpFromNudge()">
        Create free account
      </button>
      <p class="signup-nudge__reassure">It&rsquo;s free and takes about 10 seconds.</p>
      <button type="button" class="signup-nudge__later" click.trigger="account.dismissSignupNudge()">
        Not now
      </button>
    </div>
  </div>
</div>
